


import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tabs,
  Tab
} from "@mui/material";
import "./MapParameter.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";



const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const Map_ParaToDevice = () => {
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [availableParams, setAvailableParams] = useState([]);
  const [assignedParams, setAssignedParams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Reset page when switching tabs or changing the selected device
  useEffect(() => {
    setPage(0);
  }, [tabValue, selectedDevice]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  // ✅ CONSTANT HEADER CONFIGURATION
  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {}, // Matching your requirement for empty data object
  });




  const fetchCustomers = async () => {
    try {
      const res = await apiService({
        url: `/api/get_customers/`,
        method: "GET",
        data: {}
      });

      const formatted = res.data.map((c) => ({
        id: c.tb_customer_id,
        name: c.customer_name
      }));

      setCustomers(formatted);

      if (formatted.length > 0) {
        setSelectedCustomer(formatted[0].id);
        fetchDevices(formatted[0].id); // load devices for first customer
      }
    } catch (err) {
      toast.error("Failed to fetch customers");
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchDevices = async (customerId) => {
    try {
      // const customerId = localStorage.getItem("customer_id");
      // Passing getConfig() as the second argument for GET
      // const res = await axios.get(
      //   `${API_URL}/api/customer_devices/${customerId}/?page=0&pageSize=1000`, 
      //   getConfig()
      // );
      const res = await apiService({
        url: `/api/customer_devices/${customerId}/?page=0&pageSize=1000`,
        method: "GET",
        data: {}
      });
      const data = res.data.data.data.map((d) => ({ id: d.id.id, name: d.name }));
      setDevices(data);
      if (data.length > 0) {
        setSelectedDevice(data[0].id);
        fetchParameters(data[0].id);
      }
    } catch (err) {
      toast.error("Failed to fetch devices");
    }
  };

  const fetchParameters = async (deviceId) => {
    try {
      setLoading(true);

      // const [assignedRes, allRes] = await Promise.all([
      //   axios.get(`${API_URL}/api/get_device_parameters/${deviceId}/`, getConfig()),
      //   axios.get(`${API_URL}/api/get_all_parameters/`, getConfig())
      // ]);
      const [assignedRes, allRes] = await Promise.all([
        apiService({ url: `/api/get_device_parameters/${deviceId}/`, method: "GET", data: {} }),
        apiService({ url: `/api/get_all_parameters/`, method: "GET", data: {} })
      ]);

      const assigned = (assignedRes.data.parameters || []).map(p => ({
        id: p.parameter_id,
        display_name: p.display_name,
        key_name: p.key_name,
        isAssigned: true
      }));

      const allParams = (allRes.data.data || []).map(p => ({
        id: p.parameter_id,
        display_name: p.display_name,
        key_name: p.key_name
      }));

      const assignedIds = assigned.map(p => p.id);
      const available = allParams
        .filter(p => !assignedIds.includes(p.id))
        .map(p => ({ ...p, isAssigned: false }));

      setAssignedParams(assigned);
      setAvailableParams(available);
    } catch (err) {
      toast.error("Failed to fetch parameters");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => { fetchDevices(); }, []);

  const handleCustomerChange = (e) => {
    const id = e.target.value;
    setSelectedCustomer(id);

    setSelectedDevice("");
    setDevices([]);
    setAssignedParams([]);
    setAvailableParams([]);

    fetchDevices(id);
  };

  const handleDeviceChange = (e) => {
    const id = e.target.value;
    setSelectedDevice(id);
    fetchParameters(id);
  };

  const handleAction = async (param, action) => {
    const isAssigning = action === 'assign';
    const endpoint = isAssigning ? 'assign_device_parameters' : 'unassign_device_parameters';

    try {
      // For POST: 1st is URL, 2nd is BODY, 3rd is CONFIG (Headers)
      // await axios.post(
      //   `${API_URL}/api/${endpoint}/${selectedDevice}/`,
      //   { parameter_ids: [param.id] },
      //   getConfig()
      // );
      await apiService({
        url: `/api/${endpoint}/${selectedDevice}/`,
        method: "POST",
        data: { parameter_ids: [param.id] }
      });

      if (isAssigning) {
        setAssignedParams([...assignedParams, { ...param, isAssigned: true }]);
        setAvailableParams(availableParams.filter(p => p.id !== param.id));
      } else {
        setAvailableParams([...availableParams, { ...param, isAssigned: false }]);
        setAssignedParams(assignedParams.filter(p => p.id !== param.id));
      }
      toast.success(`Parameter ${isAssigning ? 'Assign' : 'Unassign'} successfully`);
    } catch (err) {
      toast.error(err.response?.data?.error || "Action failed");
    }
  };

  const getFilteredData = () => {
    if (tabValue === 1) return assignedParams;
    if (tabValue === 2) return availableParams;
    return [...assignedParams, ...availableParams];
  };

  return (
    <>
      <Paper className="main-card-ui">
        <Box className="header-row">

          <TextField
            select
            label="Select Customer"
            value={selectedCustomer}
            onChange={handleCustomerChange}
            size="small"
            className="device-select-input"
          >
            {customers.map((cust) => (
              <MenuItem key={cust.id} value={cust.id}>
                {cust.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Select Device"
            value={selectedDevice}
            onChange={handleDeviceChange}
            size="small"
            className="device-select-input"
          >
            {devices.map((dev) => <MenuItem key={dev.id} value={dev.id}>{dev.name}</MenuItem>)}
          </TextField>

          <Box className="badge-container">
            <div className="status-badge assigned">Assigned: {assignedParams.length}</div>
            <div className="status-badge available">Available: {availableParams.length}</div>
          </Box>
        </Box>

        <Box className="tabs-wrapper">
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            centered
            className="custom-tabs"
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab label="All" />
            <Tab label="Assigned" />
            <Tab label="Available" />
          </Tabs>
        </Box>

        <TableContainer className="table-container-ui orange-table">
          {loading ? (
            <Box textAlign="center" p={5}><CircularProgress /></Box>
          ) : (
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Parameter Name</TableCell>
                  <TableCell align="center">Key Name</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredData().length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center" style={{ padding: '20px', color: '#94a3b8' }}>
                      No parameters found.
                    </TableCell>
                  </TableRow>
                ) : (
                  getFilteredData().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.id}>
                        <TableCell align="center">{row.display_name}</TableCell>
                        <TableCell align="center" className="code-text">{row.key_name}</TableCell>
                        <TableCell align="center">
                          {row.isAssigned ? (
                            <Button className="btn-unmap" onClick={() => handleAction(row, 'unassign')}>Unassign</Button>
                          ) : (
                            <Button className="btn-map" onClick={() => handleAction(row, 'assign')}>Assign</Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          )}

          {/* After </TableContainer> */}
          {!loading && getFilteredData().length > 0 && (
            <div className="pagination-bar">
              <div className="rows-select">
                Rows per page:
                <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>
              <div className="page-info">
                {page * rowsPerPage + 1}-
                {Math.min((page + 1) * rowsPerPage, getFilteredData().length)} of {getFilteredData().length}
              </div>
              <div className="page-arrows">
                <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
                <button
                  disabled={(page + 1) * rowsPerPage >= getFilteredData().length}
                  onClick={() => setPage(page + 1)}
                >
                  ›
                </button>
              </div>
            </div>
          )}
        </TableContainer>
      </Paper>
      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default Map_ParaToDevice;
